import React from "react";
import GraficoAgrupado from "./GraficoAgrupado";

export default function GraficoAno(props) {
    return <GraficoAgrupado {...props} abaAtiva="ano" />;
}
